
import { useState, useEffect } from "react";
import { logger } from "@/lib/services/logger-service";
import { AIAnalysis } from "@/types/ai";
import { AIAdviceService } from "@/lib/services/ai-advice-service";

export function useAIAdvice(caregiverId: string, childId?: string) {
  const [loading, setLoading] = useState(false);
  const [advice, setAdvice] = useState<AIAnalysis | null>(null);

  // Fetch advice when caregiverId or childId changes
  useEffect(() => {
    if (caregiverId) {
      fetchAdvice();
    }
  }, [caregiverId, childId]);

  const fetchAdvice = async () => {
    setLoading(true);
    try {
      const adviceResult = await AIAdviceService.fetchAdvice(caregiverId, childId);
      
      if (adviceResult) {
        setAdvice(adviceResult);
      } else {
        // Don't show toast - the AIEmpty component already displays the error
        logger.info('No AI advice available', { caregiverId, childId });
      }
    } catch (error) {
      logger.error('Error in AIAdvice hook', { error, caregiverId, childId });
      // Don't show toast - the AIEmpty component already displays the error
    } finally {
      setLoading(false);
    }
  };

  return {
    advice,
    loading,
    fetchAdvice
  };
}
